module.exports = __webpack_public_path__ + "img/project.1c87a6e6.png";